import React, { Component } from "react";
import { getTranslation } from '../../assets/creator/translations';

class Navbar extends Component {
    navbar = () => {
        return (
            <NavbarElementWrapper {...this.props} />
        )
    }

    render = () => (
        <React.Fragment>
            {LogoWrapper}
    {this.navbar()}
    </React.Fragment>
    )
}
export default Navbar;

const NavbarElementWrapper= () => {
    return (
        <div className='navbar__wrapper'>
                <NewProjectButton />
                <button
                    className="navbar__button-link"
                    accept="text/xml"
                >
                    {getTranslation("SendXmlFile")}
                </button>
                <button
                    className="generate-btn-disabled generate-btn"
                >
                    {getTranslation("Generate")}
                </button>
                
        </div>
    )
}

const NewProjectButton = () => (
    <button className="navbar__new-project">
        {getTranslation("NewProject")}
    </button>
)

const LogoWrapper = (
    <div className='navbar__logo-wrapper'>
        <img src="../../img/comarch_logo.svg" className="navbar__logo" alt="logo" />
    </div>
);





// WEBPACK FOOTER //
// ./src/containers/Navbar/Navbar.js